module.exports = __webpack_public_path__ + "admin-thumbs/cta-block-img.png";